/* eslint-disable */
import { useState, useEffect, useRef } from 'react'
import scrollEventFn from '../scroll_event'
export default function Work(props){
  let [tabBtn] = useState(['정보입력', '서면심사'])
  let [selectTab, setSelectTab] = useState('정보입력')
  // scroll event
  const scroll01 = useRef(null)
  const scroll02 = useRef(null)
  const scroll03 = useRef(null)
  const scrollArr = [
    scroll01,
    scroll02,
    scroll03,
  ]
  useEffect(() => {
    window.scrollTo({top : 0, behavior : 'smooth'})
    // scroll event
    scrollEventFn(scrollArr)
    window.addEventListener("scroll", () => {scrollEventFn(scrollArr)})
    return () => {
      window.removeEventListener("scroll", () => {scrollEventFn(scrollArr)})
    }
  }, [])
  // html
  return(
    <div className="contents">
      <div className="content-title02">수행 업무</div>
      <div className="workBox left">
        <div className="workImg">
          <img src="/img/work-img01.png" alt=""/>
        </div>
        <div className="workTxt scrollBox" ref={scroll01}>
          ㈜DX손해사정법인은 보험사고가 발생하여 피보험자가 보험금을 청구한 경우, 고객이 제출한 서류&#40;진단서, 진료비영수증 등&#41;를 검토하고 보험회사 전산에 입력하는 일련의 정보입력 업무를 자동화함으로써 인력과 비용을 절감하고 업무처리 속도를 개선하기 위해 노력하고 있습니다.
        </div>
      </div>
      <div className="workBox right">
        <div className="workImg mob">
          <img src="/img/work-img02.png" alt=""/>
        </div>
        <div className="workTxt text-right scrollBox" ref={scroll02}>
          ㈜DX손해사정법인은 보험사고로 인하여 생긴 손해액 산정에 있어 '약관 기반 지급보험금 산출 솔루션&#40;MagicClaim&#41;'을 토대로 객관적이고 신속한 평가를 위하여 체계적인 업무 프로세스를 바탕으로 신속하고 정확하게 심사하기 위해 노력하고 있습니다.
        </div>
        <div className="workImg pc">
          <img src="/img/work-img02.png" alt=""/>
        </div>
      </div>
      <div
        className={`workTabBox scrollBox ${props.scrollUpDown == 'up' ? 'up' : ''}`}
        ref={scroll03}
      >
        {
          tabBtn.map((a, i) => (
            <button
              key={i}
              className={`workTabBtn ${a == selectTab ? 'on' : ''}`}
              onClick={() => {setSelectTab(a)}}
            >
              {a}
            </button>
          ))
        }
      </div>
      {
        selectTab == '정보입력' ?
        <div className="workCon">
          <div className="workPra">
            상해 또는 질병보험의 피보험자가 보험금을 청구한 경우, 손해사정 업무를 위하여 고객이 제출한 서류(진단서, 진료비영수증 등)를 검토하여 보험회사 전산에 입력하는 업무입니다.
          </div>
          <div className="workImgBox">
            <img src="/img/flow1.png" className="workImg01" alt=""/>
            <img src="/img/highlight.png" className="workImg02" alt=""/>
          </div>
        </div>
        :
        <div className="workCon">
          <div className="workPra">
            손해사정 업무의 일종으로 주로 상해 또는 질병보험에 가입한 피보험자가 보험기간 중 발생한 보험사고로 보험금을 청구한 경우, 청구서류 및 의료기관의 입증자료 등을 근거로 현장조사 과정 없이 비교적 간단한 사실관계 확인 과정을 거쳐 약관에 따른 손해액을 산정하고 타보험사와의 비례보상을 통해 최종 지급보험금을 산정하는 업무입니다.
          </div>
          <div className="workImgBox">
            <img src="/img/flow2.png" className="workImg01" alt=""/>
            <img src="/img/highlight.png" className="workImg02" alt=""/>
          </div>
        </div>
      }
    </div>
  )
}